export function getTabs() {
  return this.getCanvas().parent.CanvasNavbar
}

export function getTabsState() {
  return this.getRootState().activeTabs
}

export function refreshTabs() {
  this.getTabs().update()
}

export function addToTabs(key, opts = {}) {
  const platformState = this.getRootState()
  const activeTabs = this.getTabsState()
  const item = this.getSchemaItem(key)
  const type = this.getType(key)
  const routeExists = activeTabs.filter((v) => v.key === key)
  if (!routeExists.length) {
    activeTabs.push({ key, type, title: item?.title || key })
  }
  this.updateTabsLocalStorage()
  platformState.quietReplace({ activeTabs })
  if (!opts.preventUpdate) {
    this.refreshTabs()
  }
}

export function isInTabs(key) {
  const platformState = this.getRootState()
  const { activeTabs } = platformState
  return activeTabs.filter((v) => v.key === key)[0]
}

export function closeTab(key, opts = {}) {
  const platformState = this.getRootState()
  const { activeTabs } = platformState
  const activeIndex = activeTabs.findIndex((v) => v.key === key)
  if (activeIndex < 0) {
    return
  }
  if (activeTabs[activeIndex]?.key === this.getChosenKey()) {
    this.activateChosen(null)
  }
  this.call('removeFromArray', activeTabs, activeIndex)
  this.updateTabsLocalStorage()
  platformState.quietReplace({ activeTabs })
  if (!opts.preventUpdate) {
    this.refreshTabs()
  }
}

export function cleanTabs() {
  const platformState = this.getRootState()
   
  const activeTabs = (platformState.activeTabs = [])
  const key = `activeTabs_${platformState.appKey}${platformState.branch}`
  window.localStorage.removeItem(key)
  if (platformState.appKey) {
    window.localStorage.setItem(key, JSON.stringify(activeTabs))
  }
}

export function closeComponentTab() {
  const activeTabs = this.getTabsState()
  activeTabs.forEach(() => {
    // if (val.route === '/editor/' + componentKey) closeTab(key)
  })
}

export function updateTabsLocalStorage() {
  const platformState = this.getRootState()
  const { activeTabs } = platformState
  const key = `activeTabs_${platformState.appKey}${platformState.branch}`
  window.localStorage.removeItem(key)
  if (platformState.appKey) {
    window.localStorage.setItem(key, JSON.stringify(activeTabs))
  }
}
